import { htmlToPlainText } from './stringUtils';

interface ResolveFieldPlaceholderArgs {
  /** Explicit placeholder from the HubSpot field, if any. */
  placeholder?: string;
  /** The HubSpot field label (may contain rich-text markup). */
  label: string;
  /** The HubSpot field type (e.g. 'single_line_text', 'phone', 'email'). */
  fieldType: string;
}

/**
 * Resolves the placeholder text for a HubSpot form field:
 * - an explicit HubSpot placeholder is respected as-is;
 * - phone fields default to "Phone number";
 * - otherwise the field label is used, cleaned of HTML and of any "(optional)"
 *   marker so it reads as a plain hint.
 */
export const resolveFieldPlaceholder = ({
  placeholder,
  label,
  fieldType,
}: ResolveFieldPlaceholderArgs): string => {
  if (placeholder) {
    return placeholder;
  }
  if (fieldType === 'phone') {
    return 'Phone number';
  }
  return htmlToPlainText(label)
    .replace(/\s*\(optional\)\s*/gi, ' ')
    .trim();
};
